var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-protect"},[_c('Science-integrity'),_c('Privacy-protect-concept',{attrs:{"src":_vm.dataList}}),_c('Manage-system'),_c('Manage-process'),_c('AuthoritativeCertification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }